export default __webpack_public_path__ + "static/media/cuciVoucher1.62d242b7.png";